import React from 'react';
import { makeStyles } from '@mui/styles';
import { AccordionDetails, AccordionSummary, Grid, Typography } from '@mui/material';
import { CodeHighlighter } from '../index';
import { AdminProgressBar } from '../../../../components';

const useStyles = makeStyles((theme) => ({
  pre: {
    whiteSpace: 'pre-wrap',
  },
  childAccordion: {
    display: 'block',
  },
  headingPost: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
    color: theme.palette.success.main,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

const ChallengesByID = () => {
  const classes = useStyles();
  return (
    <AccordionDetails className={classes.childAccordion}>
      <Typography>
        <Grid
          container
          item
          xs={12}
          spacing={2}
          justifyContent={'space-between'}
        >
          {/*
                       <Grid item xs={2}><h3>Example Request</h3></Grid>
                      <Grid item xs={10}>
                      <pre className={classes.pre}>
                      <code>
                    </code>
                      </pre>
                      </Grid>
                      */}
          <Grid
            item
            xs={2}
          >
            <h3>Example Response</h3>
          </Grid>
          <Grid
            item
            xs={10}
          >
            <CodeHighlighter
              code={`{
    "data": {
        "id": 76,
        "name": "Eat When You're Hungry",
        "categoryID": 7,
        "groupID": 66,
        "difficultyLevel": 1,
        "icon_name": "eatOnlyWhenHungry",
        "nameInASentence": "The Eat When You're Hungry Challenge",
        "description": "Learn to recognize and respond to hunger signals, to eat more intuitively and mindfully.",
        "disclaimer": "Eating when hungry is a crucial component of mindful eating, but it isn't always as simple as it sounds. See guide for more info.",
        "generalSlipInstructions": "",
        "smallSlipInstructions": "if you ate a little when you weren't hungry",
        "veryBriefSlipInstructions": "I ate when I wasn't hungry",
        "bigSlipInstructions": "if you ate a lot even though you weren't hungry",
        "briefSuccessInstructions": "",
        "veryBriefSuccessInstructions": "I ate only when I was hungry"
    }
}`}
            />
          </Grid>
          <Grid
            item
            xs={2}
          >
            <h3>Error Response</h3>
          </Grid>
          <Grid
            item
            xs={10}
          >
            <CodeHighlighter
              code={`{
    "success": "false",
    "message": "Must be logged in"
}
  `}
            />
          </Grid>
        </Grid>
      </Typography>
    </AccordionDetails>
  );
};
const Wrapper = () => {
  return (
    <React.Suspense fallback={<AdminProgressBar />}>
      <ChallengesByID />
    </React.Suspense>
  );
};
export default Wrapper;
